module.exports = __webpack_public_path__ + "static/media/check_success.538d1400.svg";